import { AnimationTypesConstants } from "./animationTypesConstants";
export var animationSettingConstants = {
    minMaxConfigs: new Map([
        [AnimationTypesConstants.WalkingCitizens, { maxAmount: 8, minAmount: 3 }],
    ]),
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/animationSettingConstants.ts
// module id = 2200
// module chunks = 3